import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Input from "@mui/material/Input";
import Paper from "@mui/material/Paper";
import moment from "moment";
import CloudOffIcon from "@mui/icons-material/CloudOff";
import SearchIcon from "@mui/icons-material/Search";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import {
  addBriskWalletAmount,
  formatCurrency,
  getBriskWallet,
  getBriskWalletAmount,
  getBriskWalletTransStatus,
  updateBriskPaymentScreenshot,
  updateBriskWalletByID,
} from "../../Service/girnarApi";
import React from "react";
import {
  Autocomplete,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  InputAdornment,
  TextField,
  Tooltip,
} from "@mui/material";
import PropTypes from "prop-types";
import { visuallyHidden } from "@mui/utils";
import swal from "sweetalert";
import { ToastError, ToastSuccess } from "../../UiComponents/Toaster/Toast";
import { RefreshOutlined, UploadFile } from "@mui/icons-material";
import Loader from "../../UiComponents/Loader/Loader";
import {
  AccountBalanceWalletIcon,
  DownloadIcon,
} from "../../Resources/Icons/icons";
import FloatLabel from "../../UiComponents/FloatLabel/FloatLabel";
import { GetUser } from "../../Service/UserService";
import { AWS_DIRECTORY_NAME } from "../../Shared/CommonConstant";
import { FileUploader } from "react-drag-drop-files";
import { CSVLink } from "react-csv";

const BriskTransactionHistory = () => {
  const headCells = [
    {
      id: "createdAt",
      placeMent: true,
      disablePadding: false,
      label: "Transaction Date",
    },
    {
      id: "userName",
      placeMent: true,
      disablePadding: false,
      label: "User",
    },
    // {
    //   id: "linkUser",
    //   placeMent: true,
    //   disablePadding: false,
    //   label: "Link Sent User",
    // },
    // {
    //   id: "policyType",
    //   placeMent: true,
    //   disablePadding: false,
    //   label: "Policy Type",
    // },
    {
      id: "orderId",
      placeMent: true,
      disablePadding: false,
      label: "Order ID",
    },
    {
      id: "transactionId",
      placeMent: true,
      disablePadding: false,
      label: "Transaction ID",
    },
    {
      id: "status",
      placeMent: true,
      disablePadding: false,
      label: "Status",
    },
    {
      id: "amount",
      placeMent: true,
      disablePadding: false,
      label: "Amount",
    },
    {
      id: "action",
      placeMent: false,
      disablePadding: false,
      label: "Action",
    },
    // Changes by Arun
    // {
    //   id: "transactionId",
    //   placeMent: true,
    //   disablePadding: false,
    //   label: "Transaction ID",
    // },
  ];

  const FILTER_STATUS = [
    {
      label: "All",
      value: "all",
    },
    {
      label: "Success",
      value: "success",
    },
    {
      label: "Failure",
      value: "failure",
    },
  ];

  const [filterTableList, setFilterTableList] = React.useState([]);
  const [tableList, setTableList] = React.useState([]);
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("id");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [openLoader, setOpenLoader] = React.useState(false);
  const [walletBalance, setWalletBalance] = React.useState("");
  const [userDetails, setUserDetails] = React.useState([]);
  const [selectedStatus, setSelectedStatus] = React.useState("all");
  const [openUploadFileBox, setOpenUploadFileBox] = React.useState(false);
  const [fileTitle, setFileTitle] = React.useState({});
  const [uploadFiles, setUploadFiles] = React.useState({});
  const [selectedData, setSelectedData] = React.useState({});

  const [filter, setFilter] = React.useState({
    fn: (items) => {
      return items;
    },
  });

  const header = [
    { label: "Transaction Date", key: "createdAt" },
    { label: "User", key: "userName" },
    { label: "Order ID", key: "orderId" },
    {
      key: "transactionId",
      label: "Transaction ID",
    },
    { label: "Status", key: "status" },
    { label: "Amount", key: "amount" },
  ];
  const csvFile = {
    filename: "Wallet Transaction History",
    headers: header,
    data: tableList,
  };

  const UserType = sessionStorage.getItem("userType");
  const fileTypes = ["JPG", "PNG", "GIF"];

  EnhancedTableHead.propTypes = {
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.oneOf(["asc", "desc"]).isRequired,
    orderBy: PropTypes.string.isRequired,
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getUserDetails = () => {
    const bodyData = {
      requesttype: "TABLE",
      isAscending: true,
    };
    GetUser(bodyData).then((res) => {
      const ModifiedUserDetails = res.data.map((e) => {
        return {
          ...e,
          label: e.name + " - " + e.mobileNumber + " - " + e.email,
          value: e._id,
        };
      });
      setUserDetails([...ModifiedUserDetails]);
    });
  };

  const stableSort = (array, comparator) => {
    const stabilizedThis = array?.map((el, index) => [el, index]);
    stabilizedThis?.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis?.map((el) => el[0]);
  };

  const descendingComparator = (a, b, orderBy) => {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  };

  const getWallet = () => {
    getBriskWalletAmount()
      .then((res) => {
        setWalletBalance(res?.data?.balance || 0);
      })
      .catch((err) => {
        ToastError(err?.response?.data?.message || "Something went wrong");
      });
  };

  const onSearch = (e) => {
    let target = e.target;
    setFilter({
      fn: (items) => {
        if (target.value == "") return items;
        else
          return items.filter((el) =>
            `${el?.userName},${el?.status},${el?.orderId},${el?.amount}`
              .toLowerCase()
              .includes(target.value.toLowerCase()),
          );
      },
    });
    setPage(0);
  };

  const UploadFilesFunction = () => {
    let formData = new FormData();
    for (var key in uploadFiles) {
      formData.append(key, uploadFiles[key]);
    }
    formData.append(
      AWS_DIRECTORY_NAME.AWS_BRISK_SCREENSHOT_DIRECTORY_NAME,
      UploadFile.screenshotImg,
    );
    updateBriskPaymentScreenshot(selectedData?._id, formData)
      .then((res) => {
        setOpenUploadFileBox(false);
        setUploadFiles({});
        setFileTitle(null);
      })
      .catch((err) => {
        console.log(err);
        ToastError("Something Went error");
        setOpenUploadFileBox(false);
        setFileTitle(null);
      });
  };

  const getComparator = (order, orderBy) => {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  };

  const visibleRows = React.useMemo(
    () =>
      stableSort(
        filter.fn(filterTableList),
        getComparator(order, orderBy),
      )?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage),
    [order, orderBy, page, rowsPerPage, filter, filterTableList],
  );

  function EnhancedTableHead(props) {
    const { order, orderBy, onRequestSort, rejectedPolicy } = props;
    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };

    const celltoMap = headCells;

    return (
      <TableHead>
        <TableRow>
          {celltoMap?.map((headCell) => (
            <TableCell
              className="TableHeader"
              key={headCell.id}
              align={headCell.placeMent ? "left" : "center"}
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={orderBy === headCell.id ? order : false}
              sx={{ fontSize: "16px", fontWeight: 600 }}
              style={{ minWidth: headCells.minWidth }}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </Box>
                ) : null}
              </TableSortLabel>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }

  React.useEffect(() => {
    getData(selectedStatus);
    getWallet();
    // getUserDetails();
  }, []);

  const getData = (status) => {
    setOpenLoader(true);
    getBriskWallet(status)
      .then((res) => {
        console.log("res :::", res);
        setTableList(res?.data);
        setFilterTableList(res?.data);
        //setSummaryData(res?.data?.summary);
      })
      .finally(() => setOpenLoader(false));
  };

  const updateWalletStatusByID = (id, status) => {
    setOpenLoader(true);
    updateBriskWalletByID(id, status).then((res) => {
      console.log("res :::", res);
      ToastSuccess(res.data.message);
      setOpenLoader(false);
      refreshPage();
    });
  };

  const getBriskWalletTransStatusByID = (orderId, status) => {
    setOpenLoader(true);
    getBriskWalletTransStatus(orderId, status).then((res) => {
      // console.log("res :::", res);
      const status = res?.data?.data;
      if (status == "SUCCESS") {
        ToastSuccess("Transaction Successful");
      } else {
        ToastError(status ? status : "Transaction Failed");
      }
      setOpenLoader(false);
    });
  };

  const refreshPage = () => {
    getData(selectedStatus);
    getWallet();
  };

  const userFilter = (id) => {
    console.log("id   ", id);
    if (id) {
      const filterList = tableList.filter((e) => e.userId == id);
      setFilterTableList(filterList);
    } else {
      setFilterTableList(tableList);
    }
  };

  const walletTopup = () => {
    swal({
      title: "Wallet Topup",
      // text: "Please provide your name below:",
      content: {
        element: "input",
        attributes: {
          placeholder: "Enter amount",
          type: "number",
        },
      },
      buttons: {
        confirm: "PAY",
      },
    }).then((value) => {
      setOpenLoader(true);
      if (value) {
        addBriskWalletAmount({ amount: value })
          .then((res) => {
            console.log("res :::", res.data);
            // ToastSuccess(res.data.message);
            window.open(res?.data?.redirectUrl, "_blank");
          })
          .catch((err) => {
            ToastError(err?.response?.data?.message || "Something went wrong");
          })
          .finally(() => {
            setOpenLoader(false);
            refreshPage();
          });
      } else {
        console.error("no value");
        setOpenLoader(false);
      }
    });
    // swal({
    //   title: "Wallet Topup",
    //   content: (function () {
    //     let div = document.createElement("div");

    //     // Input 1: Amount
    //     let amountInput = document.createElement("input");
    //     amountInput.type = "number";
    //     amountInput.placeholder = "Enter amount";
    //     amountInput.id = "amount";
    //     amountInput.style.margin = "5px 0"; // some spacing

    //     // Input 2
    //     let mobileInput = document.createElement("input");
    //     mobileInput.type = "text";
    //     mobileInput.placeholder = "Enter Mobile Number";
    //     mobileInput.value = sessionStorage.getItem("mobileNumber"); // default value
    //     mobileInput.id = "mobileNumber";
    //     mobileInput.style.margin = "5px 0";

    //     // Input 3
    //     let emailInput = document.createElement("input");
    //     emailInput.type = "text";
    //     emailInput.placeholder = "Enter Email";
    //     emailInput.value = sessionStorage.getItem("email"); // default value
    //     emailInput.id = "email";
    //     emailInput.style.margin = "5px 0";
    //     // Append inputs
    //     div.appendChild(emailInput);
    //     div.appendChild(document.createElement("br"));
    //     div.appendChild(mobileInput);
    //     div.appendChild(document.createElement("br"));
    //     div.appendChild(amountInput);

    //     return div;
    //   })(),
    //   buttons: {
    //     cancel: "Cancel",
    //     confirm: "PAY",
    //   },
    // }).then((value) => {
    //   setOpenLoader(true);
    //   if (value) {
    //     const amount = Number(document.getElementById("amount").value);
    //     const mobileNumber = document.getElementById("mobileNumber").value;
    //     const email = document.getElementById("email").value;

    //     addBriskWalletAmount({ amount, mobileNumber, email })
    //       .then((res) => {
    //         console.log("res :::", res.data);
    //         // ToastSuccess(res.data.message);
    //         window.open(res?.data?.redirectUrl, "_blank");
    //       })
    //       .catch((err) => {
    //         ToastError(err?.response?.data?.message || "Something went wrong");
    //       })
    //       .finally(() => {
    //         setOpenLoader(false);
    //         refreshPage();
    //       });
    //   } else {
    //     console.error("no value");
    //   }
    // });
  };

  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={1} px={1} className="Master_Header_Container">
          <Grid item xs={12} sm={2}>
            <Typography
              className="Master_Header_Heading"
              sx={{ paddingLeft: "4px" }}
            >
              Transaction History
            </Typography>
          </Grid>
          <Grid item xs={12} sm={9}></Grid>
          <Grid item xs={12} sm={2} className="Count_Page">
            <Grid className="Count_2" sm={12}>
              <Typography className="Total">
                {formatCurrency(walletBalance)}
              </Typography>
              <Typography className="Title">Wallet Balance </Typography>
            </Grid>
            {/* <Button
              className="Master_Header_create_Button Common_Button w-100"
              startIcon={<AccountBalanceWalletIcon />}
            >
              Wallet Balance = {walletBalance}
            </Button> */}
          </Grid>
          <Grid item xs={12} sm={1.5}></Grid>
          {/* <Grid item sm={2.5} xs={12}></Grid> */}
          {/* <Grid item sm={2.5} xs={12}>
            <FloatLabel label="Select User">
              <Autocomplete
                className="AutoComplete_InputBox"
                id="combo-box-demo"
                options={userDetails}
                onChange={(e, v) => userFilter(v?._id)}
                renderInput={(params) => <TextField {...params} />}
                renderOption={(props, option) => (
                  <li {...props} key={option._id}>
                    {option.label}
                  </li>
                )}
              />
            </FloatLabel>
          </Grid> */}
          <Grid item xs={12} sm={2}>
            <FloatLabel label="Filter Status" value={selectedStatus}>
              <Autocomplete
                defaultValue={"Success"}
                className="AutoComplete_InputBox"
                onChange={(option, value) => {
                  setSelectedStatus(value?.value);
                  getData(value?.value);
                }}
                options={FILTER_STATUS}
                renderInput={(params) => <TextField {...params} />}
              />
            </FloatLabel>
          </Grid>
          <Grid item xs={12} sm={2}>
            <button
              className="w-100 Common_Button"
              type="button"
              onClick={() => walletTopup()}
            >
              Wallet Topup
            </button>
          </Grid>
          <Grid item xs={12} sm={2}>
            <Input
              focused="false"
              className="w-100 Master_Header_Input"
              id="standard-adornment-password"
              onChange={onSearch}
              disableUnderline={true}
              placeholder="Search"
              startAdornment={
                <InputAdornment position="start">
                  <IconButton aria-label="toggle password visibility">
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              }
            />
          </Grid>
          <Grid item xs={12} sm={2} className="d-flex justify-content-end">
            <Button
              className="Master_Header_create_Button w-100"
              endIcon={<DownloadIcon />}
              sx={{ width: { xs: "100%", sm: "fit-content" } }}
            >
              <CSVLink className="Download_Excel_Button" {...csvFile}>
                Download Excel
              </CSVLink>
            </Button>
          </Grid>
          <Grid item xs={12} sm={0.5}>
            <Tooltip title="Refresh Transaction History">
              <IconButton
                onClick={refreshPage}
                color="primary"
                aria-label="refresh"
              >
                <RefreshOutlined />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
      </Box>

      <div className="d-flex PageContainer">
        <Paper className="container-fluid TableBox">
          <TableContainer className="TableContainer">
            <Table
              aria-labelledby="tableTitle"
              size="medium"
              stickyHeader
              aria-label="sticky table"
              sx={{ minWidth: 750 }}
            >
              <EnhancedTableHead
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
              />
              <TableBody>
                {visibleRows?.map((row, index) => {
                  return (
                    <TableRow
                      hover
                      tabIndex={-1}
                      key={index}
                      sx={{ cursor: "pointer" }}
                    >
                      <TableCell align="left">
                        {new Date(row?.createdAt).toLocaleString()}
                      </TableCell>
                      <TableCell align="left">{row?.userName}</TableCell>
                      {/* <TableCell align="left">{row?.linkUser}</TableCell> */}
                      {/* <TableCell align="left">{row?.policyType}</TableCell> */}
                      <TableCell align="left">{row?.orderId}</TableCell>
                      <TableCell align="left">{row?.transactionId}</TableCell>

                      <TableCell
                        style={{
                          color: row.status === "SUCCESS" ? "green" : "red",
                          fontWeight: "bold",
                          fontSize: "12px",
                          textTransform: "uppercase",
                        }}
                        align="left"
                      >
                        {row?.status}
                      </TableCell>
                      <TableCell align="left">
                        {formatCurrency(row?.amount)}
                      </TableCell>
                      <TableCell align="center" sx={{ padding: 0 }}>
                        <Box className="ActionIcons">
                          <Button
                            variant="outlined"
                            onClick={() => {
                              updateWalletStatusByID(row._id, "SUCCESS");
                            }}
                            sx={{
                              display:
                                row.status == "CREATED" && UserType == "CLIENT"
                                  ? "flex"
                                  : "none",
                              width: {
                                backgroundColor: "green",
                                fontSize: "12px",
                                color: "white",
                                padding: "1px",
                                textTransform: "capitalize",
                                "&:hover": {
                                  color: "green",
                                },
                              },
                            }}
                          >
                            Success
                          </Button>
                          <Button
                            variant="outlined"
                            onClick={() => {
                              updateWalletStatusByID(row._id, "FAILURE");
                            }}
                            sx={{
                              display:
                                row.status == "CREATED" && UserType == "CLIENT"
                                  ? "flex"
                                  : "none",
                              width: {
                                backgroundColor: "red",
                                fontSize: "12px",
                                color: "white",
                                padding: "1px",
                                textTransform: "capitalize",
                                "&:hover": {
                                  color: "red",
                                },
                              },
                            }}
                          >
                            Failure
                          </Button>
                          <Button
                            variant="outlined"
                            onClick={() => {
                              updateWalletStatusByID(row._id, "CREATED");
                            }}
                            sx={{
                              display:
                                (row.status == "SUCCESS" ||
                                  row.status == "FAILURE") &&
                                  UserType == "CLIENT"
                                  ? "flex"
                                  : "none",
                              width: {
                                backgroundColor: "red",
                                fontSize: "12px",
                                color: "white",
                                padding: "1px",
                                textTransform: "capitalize",
                                "&:hover": {
                                  color: "red",
                                },
                              },
                            }}
                          >
                            Revert
                          </Button>
                          <Button
                            variant="outlined"
                            onClick={() => {
                              getBriskWalletTransStatusByID(row.orderId);
                            }}
                            sx={{
                              display: UserType == "CLIENT" ? "flex" : "none",
                              backgroundColor: "#1976d2",
                              fontSize: "12px",
                              color: "white",
                              padding: "2px",
                              marginRight: "4px",
                              textTransform: "capitalize",
                              "&:hover": {
                                backgroundColor: "#1565c0",
                                color: "white",
                              },
                            }}
                          >
                            Check Status
                          </Button>
                        </Box>
                      </TableCell>
                    </TableRow>
                  );
                })}
                {visibleRows?.length < 1 ? (
                  <TableRow>
                    <TableCell
                      colSpan={12}
                      sx={{ textAlign: "center", border: "none" }}
                    >
                      <CloudOffIcon
                        sx={{ fontSize: "100px", color: "#c5c3c3" }}
                      />
                      <br />
                      <Typography sx={{ color: "#c5c3c3" }}>
                        Oops! No Data Found
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : null}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={filter.fn(filterTableList)?.length || 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
        <Loader open={openLoader} />
        <div>
          <Dialog
            open={openUploadFileBox}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {"Upload Screenshot Image"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                <Grid container rowGap={1}>
                  <Grid item className="File-Upload" xs={12} sm={12}>
                    <span>Screenshot Image :</span>
                    <FileUploader
                      name="OtherFile"
                      label="Upload Your Screenshot"
                      types={fileTypes}
                      dropMessageStyle={{
                        color: "red",
                        border: "none",
                        borderRadius: "0px",
                      }}
                      handleChange={(e) => {
                        setFileTitle({ ...fileTitle, screenshotImg: e.name });
                        setUploadFiles({ ...uploadFiles, screenshotImg: e });
                      }}
                    />
                  </Grid>
                  <div className="fileTitle">
                    {fileTitle?.screenshotImg ? fileTitle?.screenshotImg : null}
                  </div>
                </Grid>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  setFileTitle(null);
                  setOpenUploadFileBox(false);
                  // setUploadFiles({});
                }}
              >
                Close
              </Button>
              <Button autoFocus onClick={() => UploadFilesFunction()}>
                Upload
              </Button>
            </DialogActions>
          </Dialog>
          <Loader open={openLoader} />
        </div>
      </div>
    </>
  );
};

export default BriskTransactionHistory;
